export const formatNumber = (num:any, precision = 0) => {
  const map = [
    { suffix: 'T', threshold: 1e12 },
    { suffix: 'B', threshold: 1e9 },
    { suffix: 'M', threshold: 1e6 },
    { suffix: 'K', threshold: 1e3 },
    { suffix: '', threshold: 1 },
  ];

  const found = map.find((x) => Math.abs(num) >= x.threshold);
  if (found) {
    const formatted = (num / found.threshold).toFixed(precision) + found.suffix;
    return formatted;
  }

  return num;
}

export const formatNumberBytes = (num:any, precision = 0) => {
  const map = [
    { suffix: 'EB', threshold: Math.pow(1024, 6) },
    { suffix: 'PB', threshold: Math.pow(1024, 5) },
    { suffix: 'TB', threshold: Math.pow(1024, 4) },
    { suffix: 'GB', threshold: Math.pow(1024, 3) },
    { suffix: 'MB', threshold: Math.pow(1024, 2) },
    { suffix: 'KB', threshold: 1024 },
    { suffix: '', threshold: 1 },
  ];

  const found = map.find((x) => Math.abs(num) >= x.threshold);
  if (found) {
    const formatted = (num / found.threshold).toFixed(precision) + found.suffix;
    return formatted;
  }

  return num;
}